// Kuch piezometer par ek-do sensor field se hata diye gaye hain, par unka
// purana telemetry data DB me pada rehta hai. Report me wo sensor bilkul nahi
// aana chahiye — na graph me, na table me.
//
// DB read-only hai, isliye filter yahan display side par lagta hai. Report.jsx
// data fetch hote hi ye filter laga deta hai, isliye screen, DOCX aur PDF —
// teeno apne aap consistent rehte hain.

// device ka naam -> jo sensor chhupane hain.
const HIDDEN_SENSORS = {
  "VWP-WP-25": ["A"],
};

const norm = (value) => String(value ?? "").trim().toUpperCase();

// Lookup ke liye sab kuch upper-case me, taaki naam ke case se farak na pade.
const rules = Object.fromEntries(
  Object.entries(HIDDEN_SENSORS).map(([device, sensors]) => [norm(device), sensors.map(norm)])
);

/**
 * Telemetry key me se sensor ka naam nikalta hai.
 *
 *   "pressure_in_kPa_B1"                              -> "B1"
 *   "Water_Level_Elevation_A (Sensor Elevation = +31)" -> "A"
 *
 * Aakhir wala bracket wala hissa pehle hataya jaata hai, warna wo last
 * underscore-segment ka hissa ban jaata aur match fail ho jaata.
 */
export const sensorOf = (key) => {
  const base = String(key ?? "").replace(/\s*\(.*\)\s*$/, "").trim();
  const match = base.match(/_([A-Za-z]\d*)$/);
  return match ? norm(match[1]) : null;
};

/**
 * Us device ke chhupe hue sensor ke data points hata deta hai.
 *
 * Sirf un items ko chhuta hai jinme `key` hoti hai (piezometer wali shape:
 * { ts, key, value }). Inclinometer ka data alag shape me aata hai, wo waise
 * ka waisa nikal jaata hai.
 */
export const withoutHiddenSensors = (deviceName, data) => {
  const hidden = rules[norm(deviceName)];
  if (!hidden || !Array.isArray(data)) return data;

  return data.filter((item) => {
    if (!item || typeof item.key !== "string") return true;
    const sensor = sensorOf(item.key);
    return !(sensor && hidden.includes(sensor));
  });
};
